import { isUndefined } from "util";
import moment from "moment-timezone";

export const initDate = "2016-10";

export const format = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }
  const d = new Date(date);
  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "long" }).format(d);
  const da = new Intl.DateTimeFormat("es", { day: "numeric" }).format(d);

  return `${da} ${mo} ${ye}`;
};

export const formatNumericDate = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }
  const d = new Date(date);
  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "numeric" }).format(d);
  const da = new Intl.DateTimeFormat("es", { day: "numeric" }).format(d);

  return `${da}/${mo}/${ye}`;
};

export const formatMonthYear = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }
  const d = new Date(date);
  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(d);

  return `${mo}-${ye}`;
};

export const formatYearMonth = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }
  const d = new Date(date);
  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(d);

  return `${ye}-${mo}`;
};

export const formatYearMonth2 = (month: number, year: number) => {
  return year + "-" + (month < 10 ? "0" + month : month);
};

export const formatDateTime = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }

  let momentDate = moment(date.substring(0, 10)).tz('America/Mexico_City').toJSON();
  const d = new Date(momentDate);

  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "long" }).format(d);
  const da = new Intl.DateTimeFormat("es", { day: "numeric" }).format(d);

  let hh = new Intl.DateTimeFormat("es", {
    hour: "2-digit",
    hour12: false,
  }).format(d);
  let mm = new Intl.DateTimeFormat("es", { minute: "2-digit" }).format(d);
  let ss = new Intl.DateTimeFormat("es", { second: "2-digit" }).format(d);

  hh = hh.length < 2 ? "0" + hh : hh;
  mm = mm.length < 2 ? "0" + mm : mm;
  ss = ss.length < 2 ? "0" + ss : ss;

  return `${da} ${mo} ${ye} ${hh}:${mm}:${ss}`;
};


export const formatDateTimewithoutTime = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }

  let momentDate = moment(date.substring(0, 10)).tz('America/Mexico_City').toJSON();
  const d = new Date(momentDate);

  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "long" }).format(d);
  const da = new Intl.DateTimeFormat("es", { day: "numeric" }).format(d);

  return `${da} ${mo} ${ye}`;
};




export const formatIso8601 = (date: string) => {
  if (isUndefined(date) || date === null || date === "") {
    return null;
  }
  const d = new Date(date);
  if (d.toString() === "Invalid Date") {
    return "Invalid Date";
  }
  const ye = new Intl.DateTimeFormat("es", { year: "numeric" }).format(d);
  const mo = new Intl.DateTimeFormat("es", { month: "2-digit" }).format(d);
  const da = new Intl.DateTimeFormat("es", { day: "2-digit" }).format(d);

  return `${ye}-${mo}-${da}`;
};

export const getFinalDay = (year: number, month: number) => {
  switch (month) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      return 31;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    case 2:
      if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        return 29;
      } else {
        return 28;
      }
  }
};

export const makeDates = (yearMonth: string) => {
  const my = yearMonth.split("-");
  const year = Number(my[0]);
  const month = Number(my[1]);
  const finalDate = getFinalDay(year, month);

  const startDate = new Date(year, month - 1, 1);
  const endDate = new Date(year, month - 1, finalDate, 23, 59, 59);

  return [startDate.toISOString(), endDate.toISOString()];
};

export const makeRangeDates = (yearMonthIni: string, yearMonthFin: string) => {
  const maxMonth = 12;
  const yearMonthIniS = yearMonthIni.split("-");
  const yearMonthFinS = yearMonthFin.split("-");
  const yearIni = Number(yearMonthIniS[0]);
  const monthIni = Number(yearMonthIniS[1]);
  const yearFin = Number(yearMonthFinS[0]);
  const monthFin = Number(yearMonthFinS[1]);
  const resp = [];

  for (let currentYear = yearIni; currentYear <= yearFin; currentYear++) {
    for (
      let currentMonth = currentYear === yearIni ? monthIni : 1;
      (currentYear === yearFin && currentMonth <= monthFin) ||
      (currentYear < yearFin && currentMonth <= maxMonth);
      currentMonth++
    ) {
      resp.push(makeDates(currentYear + "-" + currentMonth));
    }
  }

  return resp;
};

export const defaultProps = {
  monthNames: [
    ["Ene", "Feb", "Mar"],
    ["Abr", "May", "Jun"],
    ["Jul", "Ago", "Sep"],
    ["Oct", "Nov", "Dic"],
  ],
};

const dd = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export const formatdate = (month, year) => {
  let dmes = "";
  dd.forEach(function (val, idx) {
    if (idx + 1 === month) {
      dmes = val;
    }
  });
  return `${dmes + " " + year}`;
};

export const MomentFormatDate = (startDate, endDate) => {
  let yearMonthInit = startDate.split("-");
  let yearMonthEnd = endDate.split("-");
  const maxMonth = 12;
  const yearStart = Number(yearMonthInit[0]);
  const monthStart = Number(yearMonthInit[1]);
  const yearEnd = Number(yearMonthEnd[0]);
  const monthEnd = Number(yearMonthEnd[1]);
  let resp = [];

  for (let currentYear = yearStart; currentYear <= yearEnd; currentYear++) {
    for (
      let currentMonth = currentYear === yearStart ? monthStart : 1;
      (currentYear === yearEnd && currentMonth <= monthEnd) ||
      (currentYear < yearEnd && currentMonth <= maxMonth);
      currentMonth++
    ) {
      let dateAux = new Date();
      dateAux.setFullYear(currentYear);
      dateAux.setMonth(currentMonth - 1);
      let lastDay = new Date(dateAux.getFullYear(), dateAux.getMonth() + 1, 0);
      let dateBeginMoment = moment(
        new Date(currentYear, currentMonth - 1, 1, 0, 0, 0)
      );
      let dateEndsMoment = moment(
        new Date(currentYear, currentMonth - 1, lastDay.getDate(), 23, 59, 59)
      );

      let finalDateBegin = new Date(
        dateBeginMoment.tz("America/Mexico_City").format()
      ).toJSON();
      let finalDateEnd = new Date(
        dateEndsMoment.tz("America/Mexico_City").format()
      ).toJSON();

      resp.push([finalDateBegin, finalDateEnd]);
    }
  }
  return resp;
};

export const dateToString = (date) => {
  return moment(date).utc().format("DD MMM YYYY")
}